// extracted by mini-css-extract-plugin
module.exports = {"container":"AIScript_container__Dwmb3","button":"AIScript_button__ObZWE","floatContainer":"AIScript_floatContainer__ngQ3M"};